































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import actions from "../store/constants";
import anime from "animejs";

@Component({
  components: {}
})
export default class LoadingScreen extends Vue {
  @State(state => state.app.backgroundImagesLoaded) backgroundImagesLoaded!: boolean;

  enable = true;
  show = true;
  loadingPercent = 0;
  minimalShowTimeMs = 3700;
  screenEnterTimestamp = new Date().getTime();

  $refs!: {
    svgLogo: Element;
    name: Element;
    loadingLineBg: Element;
    loadingLine: SVGCircleElement;
    curtains: Element;
    content: Element;
  };

  mounted() {
    if (this.enable) {
      this.showLoading();
    } else {
      /* let checkInterval = setInterval(() => {
         if (this.backgroundImagesLoaded) {
           clearInterval(checkInterval);*/
      this.$nextTick(() => {
        this.$store.dispatch(actions.loadingScreenHide);
        this.show = false;
        setTimeout(() => {
          this.$store.dispatch(actions.loadingScreenAnimationEnded);
        }, 1800);
      });
      /*  }
      }, 100);*/
    }
  }

  /** Движение линии загрузки */
  animateLoadingLine() {
    // Появление фонового круга
    anime({
      targets: this.$refs.loadingLineBg,
      duration: 400,
      opacity: [0, 1],
      easing: "linear",
      delay: 700,
      complete: () => {
        // Заполнение круга-индикатора загрузки
        //************************************/
        // процент заполнения
        let percent = 0,
          screenHideCalled = false,
          handleLineStateChange = () => {
            let zeroOffset = 616;
            let currentOffset = 616 - (616 * percent) / 100;

            this.$refs.loadingLine!.style.strokeDashoffset = `${currentOffset}`;

            if (percent == 100 && !screenHideCalled) {
              // Если круг заполнен полностью.
              // Ждем если нужно пока пройдет минимальное время отображения экрана загрузки,
              // и скрываем его
              screenHideCalled = true;
              let waitTime =
                this.minimalShowTimeMs -
                (new Date().getTime() - this.screenEnterTimestamp);
              if (waitTime < 0) waitTime = 0;
              setTimeout(() => {
                this.hideLoadScreen();
              }, waitTime + 350);
            }
          };

        let checkInterval = setInterval(() => {
          switch (document.readyState) {
            case "interactive":
              if (percent < 40) percent = 40;
              if (percent < 60) percent += 0.1;
              break;
            case "complete": {
              percent = 100;
              break;
            }
          }

          if (percent > 100) percent = 100;
          if (percent == 100) clearInterval(checkInterval);
          handleLineStateChange();
        }, 100);
      }
    });
  }

  hideLoadScreen() {
    this.$nextTick(() => {
      this.$store.dispatch(actions.loadingScreenHide);
      this.hideLogo();

      setTimeout(() => {
        this.$store.dispatch(actions.loadingScreenAnimationEnded);
      }, 1700);

      // Убираем экран загрузки
      setTimeout(() => {
        this.show = false;
      }, 550);
    });
  }

  /** Анимация появления логотипа */
  showLoading() {
    this.animateLoadingLine();
    let paths = this.$refs.svgLogo.querySelectorAll("path");

    // Прорисовка логотипа
    anime({
      targets: paths,
      duration: 1100,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutCubic",
      delay: function (el, i) {
        return 500 + i * 350;
      },
      complete: () => {
        anime({
          targets: paths,
          duration: 550,
          fill: ["transparent", "#c9bf95"],
          stroke: "#c9bf95",
          easing: "easeInOutCubic"
        });
      }
    });

    // Появление названия
    anime({
      targets: this.$refs.name,
      duration: 700,
      opacity: [0, 1],
      top: [30, 0],
      delay: 2350,
      easing: "easeOutQuad"
    });
  }

  /** Анимация исчезания логотипа */
  hideLogo() {
    anime({
      targets: this.$refs.content,
      duration: 500,
      opacity: [1, 0],
      top: ["50%", "40%"],
      easing: "easeOutQuad"
    });
  }
}
